function changeLocale({ state, input, services }) {
  let locale = input.option.value
  state.set('client.selectedLocale', locale)
}

export default changeLocale



// WEBPACK FOOTER //
// ./src/modules/client/actions/changeLocale.js